import { ReactComponent as SvgError } from 'public/assets/icons/empty.svg';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface IProps {
  className?: string;
  children?: string;
}

export const EmptyBlock = (
  { className, children }: IProps,
) => (
  <div className={classNames(styles.box, className)}>
    <SvgError />
    {children}
  </div>
);
